module.exports = __webpack_public_path__ + "94314ffa943ddbcb77cfaba004ef7942.svg";